<template>
  <v-row class="content mb-8 pa-0">
    <v-col class="icon col-3 col-sm-1">
      <v-icon class="action-icon pa-1">{{ icons[element.action] }}</v-icon>
      <v-divider
        class="vertical-divider"
        vertical
      />
    </v-col>
    <v-col class="description col-9 col-sm-11">
      <div class="date">{{ formattedDate(element.date) }}</div>
      <div class="log-content my-2">
        <span class="label">{{ element.label }} </span>
        <span>{{ $t(`crm.activityLog.${element.action}`) }} </span>
        <span class="field">{{ $t(`main.enums.fields.${element.field}`) }}</span>
      </div>
      <div class="source">
        {{ $t('crm.activityLog.source') }}
        {{ $t(`main.enums.brands.${element.source}`) }}
      </div>
    </v-col>
  </v-row>
</template>

<script>
  export default {
    props: {
      element: {
        type: Object,
        required: true,
      },
    },
    data() {
      return {
        icons: {
          create: 'mdi-pencil-outline',
          delete: 'mdi-delete-outline',
          update: 'mdi-refresh',
        },
      }
    },
    methods: {
      formattedDate(date) {
        const localDate = new Date(date)
        localDate.setTime(localDate.getTime() + 2 * 60 * 60 * 1000)

        return `${this.$d(new Date(localDate), 'short')}
        ${this.$tc('common.at')}
        ${this.$d(new Date(localDate), 'time')}`
      },
    },
  }
</script>

<style lang="scss" scoped>
.content {
  padding-left: 10px;
  .icon {
    .action-icon {
      color: $color-009ee0;
      border: 1.4px solid $color-f3f6fe;
      border-radius: 4px;
    }
    .vertical-divider {
      display: list-item;
      margin-left: 15px;
      list-style: none;
    }
  }
  .description {
    .date {
      color: $color-4d4d4f;
      font-size: 0.875em;
      line-height: 1.25em;
    }
    .log-content {
      padding: 22px 24px;
      background-color: $color-fafbff;
      border-radius: 4px;
      .label,
      .field {
        color: $color-009ee0;
        font-size: 1em;
        font-weight: 500;
        letter-spacing: 0.24px;
        line-height: 1.5em;
        text-transform: capitalize;
      }
    }
    .source {
      color: $color-001c4b;
      font-size: 0.875em;
      line-height: 1.25em;
      text-transform: capitalize;
    }
  }
  @media (min-width: 1024px) {
    .icon {
      width: 5%;
      flex: 0 0 5%;
    }
    .description {
      width: 95%;
      flex: 0 0 95%;
    }
  }
}
</style>
